var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("section", { attrs: { id: "knowledge-base-content" } }, [
        _c(
          "div",
          { staticClass: "app-icons" },
          _vm._l(_vm.filteredKB, function (item, index) {
            return _c(
              "div",
              { key: item.id, staticClass: "kb-search-content" },
              [
                _c(
                  "div",
                  {
                    staticClass: "card",
                    class: {
                      "coming-soon": !_vm.HasPermission(item.permission),
                    },
                    on: {
                      click: function ($event) {
                        _vm.showModal(item, _vm.HasPermission(item.permission))
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "card-img",
                      attrs: { src: item.img, alt: item.title },
                    }),
                    !_vm.HasPermission(item.permission)
                      ? _c("div", { staticClass: "card-overlay" }, [
                          _c("span", { staticClass: "lock-icon" }, [
                            _vm._v("🔒"),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c("h6", { staticClass: "text-center card-title" }, [
                  _vm._v(_vm._s(_vm.t(item.title))),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            id: "module-details-modal",
            centered: "",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(" " + _vm._s(_vm.selectedModule.title) + " ")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.isModalVisible,
            callback: function ($$v) {
              _vm.isModalVisible = $$v
            },
            expression: "isModalVisible",
          },
        },
        [
          _vm.hasViewPermission
            ? _c("b-table", {
                staticClass: "mt-1",
                attrs: {
                  items: _vm.selectedModule.steps,
                  fields: _vm.stepFields,
                  small: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(step)",
                      fn: function (data) {
                        return [_vm._v(" " + _vm._s(data.item.step) + " ")]
                      },
                    },
                    {
                      key: "cell(action)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "btn-icon",
                                  attrs: {
                                    variant: "outline-primary",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUrl(data.item.buttonLink)
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "ArrowRightIcon" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3141244614
                ),
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-2",
                  attrs: {
                    variant: "success",
                    href: _vm.selectedModule.pdfUrl,
                    target: "_blank",
                    download: "",
                  },
                },
                [_vm._v(" User Manual ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "knowledge-base-search" } }, [
      _c("h2", { staticClass: "text-primary mb-3" }, [_vm._v("List Modules")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }